import difference_in_days from 'date-fns/difference_in_days';
import format from 'date-fns/format';
const minute = 60;
const hours = 60 * minute;
const day = 24 * hours;
export function getTimeAgo(time) {
    if (!time)
        return '';
    const now = new Date().getTime();
    const ago = new Date(time * 1000);
    const diff = now / 1000 - time;
    if (diff >= day) {
        if (diff >= 3 * day) {
            const diffDays = difference_in_days(now, ago);
            if (diffDays < 7) {
                return `${diffDays}天前`;
            }
            return format(ago, 'MM-DD');
        }
        if (diff >= 2 * day) {
            return '前天';
        }
        return '昨天';
    }
    if (diff >= hours) {
        return `${Math.floor(diff / hours)}小时前`;
    }
    if (diff >= minute) {
        return `${Math.floor(diff / minute)}分钟前`;
    }
    return '刚刚';
}
const hour = 60 * 60;
const minutes = 60;
export function formatPlayerTime(duration) {
    if (!duration) {
        return '00:00';
    }
    try {
        const dur = Number(duration);
        const h = Math.floor(dur / hour);
        const m = Math.floor((dur % hour) / minutes);
        const s = dur % minutes;
        return `${h ? `${fillZero(h)}:` : ''}${fillZero(m)}:${fillZero(s)}`;
    }
    catch (error) {
        console.error(error);
        return `${duration}`;
    }
}
function fillZero(n) {
    return n <= 9 ? `0${n}` : n;
}
